import { Component, OnInit, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

const ICONS_FOLDER = '/assets/icons/';
const ICON_COPIED_SMALL = '16/checkmark.svg';
const ICON_COPIED = 'icon-copied.svg';
const ICON_COPY_SMALL = '16/copy.svg';
const ICON_COPY = 'icon-copy.svg';

@Component({
  selector: 'app-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  host: {
    '[class]': '"inline-flex items-center"',
  },
  standalone: false,
})
export class CopyToClipboardComponent implements OnInit {
  @Input() public toCopy!: string | string[];
  @Input() public small = false;
  public copied = false;

  iconCopied = `${ICONS_FOLDER}${ICON_COPIED}`;
  iconCopy = `${ICONS_FOLDER}${ICON_COPY}`;

  constructor(private clipboard: Clipboard) {}

  ngOnInit() {
    if (this.small) {
      this.iconCopied = `${ICONS_FOLDER}${ICON_COPIED_SMALL}`;
      this.iconCopy = `${ICONS_FOLDER}${ICON_COPY_SMALL}`;
    }
  }

  copyText() {
    this.clipboard.copy(Array.isArray(this.toCopy) ? this.toCopy.join('\n') : this.toCopy);
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 1500);
  }
}
